import { TEXT_COLOR } from '../../theme';

export const PAGE_BG = '#F6F7FB';
export const CARD_BG = '#FFFFFF';
export const BORDER = '#CBD5E1';
export const PRIMARY = '#1F3A8A';
export const PRIMARY_HOVER = '#162d6e';
export const TEXT_MAIN = TEXT_COLOR;
export const TEXT_MUTED = TEXT_COLOR;
export const SUCCESS_COLOR = '#16A34A';
export const SUCCESS_HOVER = '#15803d';
export const SUCCESS_BG = '#DCFCE7';
export const ERROR_COLOR = '#DC2626';
export const ERROR_BG = '#FEE2E2';
export const WARNING_COLOR = '#D97706';
export const PROGRESS_BG = '#E2E8F0';
export const BORDER_HOVER = '#94A3B8';
export const INPUT_BG = '#FAFBFC';
export const LEAVE_COLOR = '#2563EB';
export const LEAVE_BG = '#DBEAFE';
export const INPUT_RADIUS = '8px';
export const CARD_RADIUS = '12px';
export const FONT = "'Inter', 'Geist', system-ui, sans-serif";

// Escala tipográfica del quiz (basada en la pantalla de bienvenida).
export const FS_TITLE = { xs: '1.4rem', sm: '1.65rem' }; // títulos principales
export const FS_SUBTITLE = '1.125rem';                   // subtítulos / encabezados de sección
export const FS_BODY = '0.9375rem';                      // texto, inputs y botones
export const FS_LABEL = '0.875rem';                      // etiquetas, notas y contadores
